import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import MuiAppBar from "material-ui/AppBar";
import muiThemeable from "material-ui/styles/muiThemeable";
import compose from "recompose/compose";
import {toggleSidebar as toggleSidebarAction} from "admin-on-rest";
import {BMTheme} from "../../BMTheme";

const AppBar = ({toggleSidebar}) => (
  <MuiAppBar
    onLeftIconButtonTouchTap={toggleSidebar}
    style={
      {
        backgroundColor: BMTheme.palette.primary1Color, 
        height: "74px", 
        alignItems: "center"}
    }
  />
);

AppBar.propTypes = {
  toggleSidebar: PropTypes.func.isRequired
};

const enhance = compose(
  muiThemeable(), // force redraw on theme change
  connect(
    null,
    {
      toggleSidebar: toggleSidebarAction
    }
  )
);

export default enhance(AppBar);



// WEBPACK FOOTER //
// ./src/components/CRM/AppBar.js